<template>
  <div class="cardio-drugs">
    <one-to-many
      :editable="!schema.disabled"
      :model="model"
      :schema="schema"
    >
      <div style="line-height: 18px;" :slot="schema.model+'-item-header'" slot-scope="slotData">
        <strong class="d-block">{{ slotData.item.name }}</strong>
        <div>
          <span>{{ slotData.item.code }} / {{ slotData.item.atc }}</span>
        </div>
        <div>
          {{ slotData.item.terminationReason }}
        </div>
      </div>
    </one-to-many>
  </div>
</template>

<script>
    import VueFormGenerator from 'vue-form-generator'
    import OneToMany from '../OneToMany'
    import { abstractField } from 'vue-form-generator'

    export default {
        mixins: [abstractField],
        components: {
            OneToMany,
        },
        props: {
            model: {
                type: Object,
                required: true,
            },
            schema: {
                type: Object,
                required: true,
            },
            editable: {
                type: Boolean,
                required: false,
                'default': true,
            },
        },
        name: 'VszpDrugs',
        created() {
            if ('function' === typeof this.schema.disabled) {
                this.schema.disabled = this.schema.disabled(this.model)
            }
            this.schema.fields = [
                {
                    type: 'input',
                    inputType: 'text',
                    label: this.t('Code'),
                    model: 'code',
                    maxLength: 20,
                    required: true,
                    validator: VueFormGenerator.validators.string,
                    disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                }, {
                    type: 'input',
                    inputType: 'text',
                    label: this.t('ATC code'),
                    model: 'atc',
                    maxLength: 7,
                    required: true,
                    validator: VueFormGenerator.validators.required,
                    disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                }, {
                    type: 'input',
                    inputType: 'text',
                    label: this.t('Drug name'),
                    model: 'name',
                    disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                }, {
                    type: 'textArea',
                    label: this.t('Termination reason'),
                    model: 'terminationReason',
                    disabled: this.accepted || this.hasPermission('ApplicationsTitan', 'U') === false,
                },
            ];
        },
    }
</script>

<style lang="scss">
  .cardio-drugs {
    width: 100%;
  }

  .cardio-drugs .vfg-form-group .titan-select, .vfg-form-group .custom-filed, .vfg-form-group .wrapper {
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/core/Form/Fields/VszpDrugs.vue